import React, { Fragment } from "react";
import DataTable from "react-data-table-component";

const FCTable = ({
  tableData,
  tableColumns,
  pagination,
  tableCustomStyles,
  selectableRows,
  onRowClicked,
  highlightOnHover,
  className,
  ...rest // Capture all other props
}) => {
  const customStyles = {
    table: {
      style: {
        backgroundColor: "#58595a",
        borderRadius: "10px",
        overflow: "hidden",
      },
    },

    headRow: {
      style: {
        backgroundColor: "#58595a",
        minHeight: "52px",
        fontSize: "16px",
        color: "#fff",
        fontWeight: "400",
        lineHeight: "24px",
        border: "none",
        borderBottom: "1px solid #FFF !important",
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px",
        paddingRight: "8px",
      },
    },
    rows: {
      style: {
        color: "#fff",
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        minHeight: "62px",
        borderRadius: "0",
        background: "#58595a",

        "&:hover": {
          backgroundColor: "#58595a !important",
          color: "#fff !important",
          fontSize: "16px !important",
          fontWeight: "500 !important",
          lineHeight: "24px !important",
          minHeight: "62px !important",
          borderRadius: "0 !important",
        },
      },
    },
    cells: {
      style: {
        justifyContent: "center",
        display: "flex",
      },
    },
    ...(tableCustomStyles && { ...tableCustomStyles }),
  };

  // Filter out the `maxWidth` prop from the rest of the props
  const filteredProps = Object.keys(rest).reduce((acc, key) => {
    if (key !== "maxWidth") {
      acc[key] = rest[key];
    }
    return acc;
  }, {});

  return (
    <Fragment>
      <DataTable
        data={tableData}
        columns={tableColumns}
        center={true}
        responsive={true}
        pagination={pagination || false}
        selectableRows={selectableRows || false}
        customStyles={customStyles}
        onRowClicked={onRowClicked}
        highlightOnHover={highlightOnHover}
        className={className || ""}
        {...filteredProps} // Pass the filtered props
      />
    </Fragment>
  );
};

export default FCTable;

// import React, { Fragment } from "react";
// import DataTable from "react-data-table-component";

// const FCTable = ({
//   tableData,
//   tableColumns,
//   pagination,
//   tableCustomStyles,
//   selectableRows,
//   onRowClicked,
//   highlightOnHover,
//   className,
// }) => {
//   const customStyles = {
//     table: {
//       style: {
//         backgroundColor: "#58595a",
//         borderRadius: "10px",
//         overflow: "hidden",
//       },
//     },

//     headRow: {
//       style: {
//         backgroundColor: "#58595a",
//         minHeight: "52px",
//         fontSize: "16px",
//         color: "#fff",
//         fontWeight: "400",
//         lineHeight: "24px",
//         border: "none",
//         borderBottom: "1px solid #FFF !important",
//       },
//     },
//     headCells: {
//       style: {
//         paddingLeft: "8px",
//         paddingRight: "8px",
//       },
//     },
//     rows: {
//       style: {
//         color: "#fff",
//         fontSize: "16px",
//         fontWeight: "500",
//         lineHeight: "24px",
//         minHeight: "62px",
//         borderRadius: "0",
//         background: "#58595a",

//         "&:hover": {
//           backgroundColor: "#58595a !important",
//           color: "#fff !important",
//           fontSize: "16px !important",
//           fontWeight: "500 !important",
//           lineHeight: "24px !important",
//           minHeight: "62px !important",
//           borderRadius: "0 !important",
//         },
//       },
//     },
//     cells: {
//       style: {
//         justifyContent: "center",
//         display: "flex",
//       },
//     },
//     ...(tableCustomStyles && { ...tableCustomStyles }),
//   };

//   return (
//     <Fragment>
//       <DataTable
//         data={tableData}
//         columns={tableColumns}
//         center={true}
//         responsive={true}
//         pagination={pagination || false}
//         selectableRows={selectableRows || false}
//         customStyles={customStyles}
//         onRowClicked={onRowClicked}
//         highlightOnHover={highlightOnHover}
//         className={className || ""}
//       />
//     </Fragment>
//   );
// };

// export default FCTable;
